module.exports = __webpack_public_path__ + "static/plain-bold-991194d3ff89c661e3ca551ccce16c5b.woff2";